import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { Menu as BaseMenu } from "@base-ui/react/menu";
import FAB from "./FAB";
import { colorOf } from "../../utils/propTypes";
import css from "./FABMenu.module.css";

const FABMenuRoot = React.forwardRef(
  (
    {
      icon,
      label = "Actions",
      open,
      onOpenChange,
      color,
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <BaseMenu.Root open={open} onOpenChange={onOpenChange}>
      <div ref={ref} className={clsx(css.root, className)} {...rest}>
        <BaseMenu.Portal>
          <BaseMenu.Positioner side="top" align="end" sideOffset={8}>
            <BaseMenu.Popup className={css.popup}>{children}</BaseMenu.Popup>
          </BaseMenu.Positioner>
        </BaseMenu.Portal>
        <BaseMenu.Trigger
          render={<FAB icon={icon} label={label} color={color} />}
        />
      </div>
    </BaseMenu.Root>
  ),
);

FABMenuRoot.displayName = "FABMenu";

FABMenuRoot.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  color: colorOf(
    "primary-container",
    "surface",
    "secondary-container",
    "tertiary-container",
  ),
  className: PropTypes.string,
  children: PropTypes.node,
};

const FABMenuItem = React.forwardRef(
  ({ icon, label, onClick, className, ...rest }, ref) => (
    <BaseMenu.Item
      ref={ref}
      className={clsx(css.menuItem, className)}
      onClick={onClick}
      {...rest}
    >
      <FAB size="sm" icon={icon} label={label} color="surface" tabIndex={-1} />
      {label && <span className={css.menuLabel}>{label}</span>}
    </BaseMenu.Item>
  ),
);

FABMenuItem.displayName = "FABMenu.Item";

FABMenuItem.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

const FABMenu = {
  Root: FABMenuRoot,
  Item: FABMenuItem,
};

export default FABMenu;
